import { render, staticRenderFns } from "./Lables.vue?vue&type=template&id=24690640"
import script from "./Lables.vue?vue&type=script&lang=js"
export * from "./Lables.vue?vue&type=script&lang=js"
import style0 from "./Lables.vue?vue&type=style&index=0&id=24690640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports